import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import { useParams } from "react-router-dom";
import '../css/ViewRequisition.css';
import Sidebar from './Sidebar';
import Select from "react-select";
import '../css/ReviewRequisition.css';
import { DateTime } from "luxon";
import styled from "styled-components";
import PrintSurrenderButton from './PrintSurrenderButton';
import ExportPDFButton from './ExportPDFButton';
import ExportExcelButton from './ExportExcelButton';
import { useMemo } from "react"; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheckCircle,
  faTimesCircle, 
  faWifi,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';

import LoadingOverlay from "./LoadingOverlay";
import PopupModal from "./PopupModal";
import CustomPopupModal from "./CustomPopupModal";


const districts = [
  "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", "Kasungu",
  "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza", "Mzimba", "Neno",
  "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
];

const costDriversList = [
  "FCI Staff Perdiem",
  "Partners DSA",
  "Government Staff DSA -AEDC, AEDO LVCDO",
  "Field Staff DSA",
  "Venue/Hall Hire",
  "Snacks",
  "Refreshments",
  "Lunch Allowance",
  "Transport Refund",
  "Stationery",
  "Scanning, printing & photocopy",
  "Training Materials",
  "PA System hire",
  "Genset Hire",
  "Vehicle Hire",
  "Vehicle Fuel",
  "Toll Gate Fee",
  "Other"
];

const supportDocumentsMap = {
  "FCI Staff Perdiem": "DSA Form, Attendance Register",
  "Partners DSA": "DSA Form, Attendance Register",
  "Government Staff DSA -AEDC, AEDO LVCDO": "DSA Form, Attendance Register",
  "Field Staff DSA": "DSA Form, Attendance Register",
  "Venue/Hall Hire": "Receipt(s)",
  "Snacks": "Receipt(s)",
  "Refreshments": "Receipt(s)",
  "Lunch Allowance": "Attendance Register, Lunch Allowance Form",
  "Transport Refund": "Transport Refund Form, Attendance Register",
  "Vehicle Hire": "Millage Form/Vehicle Log Book",
  Other: "Type the support document",
  default: "Receipt(s)",
};

const StyledInput = styled.input`
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 16px;
  width: 100%;

  &::placeholder {
    font-size: 12px;
    color: grey;
  }
`;

const districtOptions = districts.map(district => ({
  value: district,
  label: district
}));



const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  if (typeof dateString === "string") {
    const m = dateString.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
  }
  const d = new Date(dateString);
  if (isNaN(d)) return "";
  return d.toISOString().split("T")[0]; 
};


const formatDateForDisplay = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
};

const formatCurrency = (value) => {
  if (value == null || value === "" || Number(value) === 0) return "0";
  const num = Number(value) || 0;
  return `MK ${num.toLocaleString('en-US')}`;
};

const toNumber = (v) => {
  if (v == null) return 0;
  const cleaned = String(v).replace(/mk/i, "").replace(/,/g, "").trim();
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
};



const formatCurrencyForSecondTable = (value) => {
  const num = toNumber(value);       
  if (num === 0) return "0";         
  return `MK ${num.toLocaleString("en-US")}`;
};



const ReviewSurrender = () => {
  const [duplicateFilePopup, setDuplicateFilePopup] = useState({
    show: false,
    duplicateFileName: "",
  });
const navigate = useNavigate();
const [isSubmitting, setIsSubmitting] = useState(false);
const [showModal, setShowModal] = useState(false);
const [showErrorModal, setShowErrorModal] = useState(false);
const [showNoInternetModal, setShowNoInternetModal] = useState(false);
const [showselectNextReviewerModal, setShowselectNextReviewerModal] = useState(false);


const [originalSurrenderData, setOriginalSurrenderData] = useState(null);
const [showCompleteModal, setShowCompleteModal] = useState(false);
const [showSurrenderProcessCompleteModal, setShowSurrenderProcessCompleteModal] = useState(false);

const [showTooltip, setShowTooltip] = useState(false);
const [highlightNextLabel, setHighlightNextLabel] = useState(false);
const [isCompleting, setIsCompleting] = useState(false);


const [users, setUsers] = useState([]); 
const [isConfirmed, setIsConfirmed] = useState(false);
const signatureFilePath = localStorage.getItem("signatureFilePath");
const fullName = localStorage.getItem('fullName') || "Name";
const currentUser = { id: localStorage.getItem('userId') };
const [reviewers, setReviewers] = useState([]);

const [reviewData, setReviewData] = useState({
  nextReviewerId: '',
  currentReviewerNumber: null
});
  
  const { requisitionID } = useParams();
  const [surrender, setSurrender] = useState(null);
  const [local, setLocal] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [costDriverOptions] = useState(costDriversList.map(cd => ({ value: cd, label: cd })));
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const contentRef = useRef(null); 
  const theUserType = localStorage.getItem('userType'); 
  const isSurrenderReviewer = (theUserType || "").toLowerCase() === "surrender reviewer";

  const [hasChanges, setHasChanges] = useState(false);
  const formData = new FormData();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
   const [costDriversData, setCostDriversData] = useState([
     {
       costDriver: "",
       quantity: "",
       unitPrice: "",
       actualSpent: "",
       selectedFiles: [],
       isCustom: false,
       isNew: false, 
       attachmentType: "" 
     },
   ]);
 const [requisition, setRequisition] = useState(null);
   
 const [surrenderFormData, setSurrenderFormData] = useState({
    districtAndAreaProgramPairs: [],
    numberOfClientsAchieved: ''
  });

  const [costDriverActuals, setCostDriverActuals] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/surrender/${requisitionID}`);
    setSurrender(response.data);
    setOriginalSurrenderData(response.data);
    console.log("Original data loaded:", response.data);
    console.log('CostDriverActuals data:', response.costDriverActuals);
  };
  fetchData();
}, [requisitionID]);



const getUserId = (u) => u.id ?? u.Id ?? u.userName ?? u.email;
const currentUserId = localStorage.getItem("userId") || localStorage.getItem("userID") || localStorage.getItem("id") || null;

const currentReviewer = (users || []).find(u => getUserId(u) === (currentUserId ?? null));



const allowedReviewerTypes = ["surrender reviewer users", "reviewer user"];

const [nextReviewerId, setNextReviewerId] = useState("");


const currentReviewerNumber = Number(
  currentReviewer?.reviewerNumber ??
  currentReviewer?.ReviewerNumber ??
  localStorage.getItem("reviewerNumber") ??
  0
);

const reviewerOptions = (users || [])
.filter(u => {
  const ut = (u.userType || "").toString().toLowerCase();
  return allowedReviewerTypes.includes(ut);
})
.map(u => ({
  value: getUserId(u),
  label: `${(u.firstName||"").trim()} ${(u.lastName||"").trim()}`.trim(),
  reviewerNumber: Number(u.reviewerNumber ?? u.ReviewerNumber ?? 0),
  raw: u
}));



const fetchSurrenderData = async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/surrender/${requisitionID}`);
    const data = response.data || {};

    console.log('=== FULL API RESPONSE ===');
    console.log('advanceActualsAndVariances:', data.advanceActualsAndVariances);

    if (data.advanceActualsAndVariances && data.advanceActualsAndVariances.length > 0) {
      console.log('First advance row structure:', data.advanceActualsAndVariances[0]);
      console.log('All advance row keys:', data.advanceActualsAndVariances.map(row => Object.keys(row)));
    }

    const pickDateField = (obj, candidates) => {
      for (const k of candidates) {
        if (obj && obj[k] != null && obj[k] !== "") return obj[k];
      }
      return undefined;
    };

    // FIXED: Map costDriverActuals from data, not mapped
    const costDriverActuals = Array.isArray(data.costDriverActuals)
      ? data.costDriverActuals.map(cd => ({
          ...cd,
          costDriver: cd.costDriver ?? "",
          customCostDriver: cd.customCostDriver ?? "",
          isCustom: cd.isCustom ?? false,
          quantity: cd.quantity ?? "",
          unitPrice: cd.unitPrice ?? "",
          actualSpent: cd.actualSpent ?? "",
          attachmentType: cd.attachmentType ?? "physical",
          selectedFiles: [],
          supportDocuments: Array.isArray(cd.supportDocuments) ? cd.supportDocuments : [],
          justification: cd.justification || "",
          reasonForVariance: cd.reasonForVariance || "", // ADDED THIS LINE
          isNew: !!cd.isNew,
          isNewInReview: !!cd.isNewInReview
        }))
      : [];

    const advanceActualsAndVariances = Array.isArray(data.advanceActualsAndVariances)
      ? data.advanceActualsAndVariances
      : [];

    const districtPairs = Array.isArray(data.districtAndAreaProgramPairsActuals)
      ? data.districtAndAreaProgramPairsActuals
      : [];

    const mapped = {
      ...data,
      costDriverActuals, // Now this uses the properly mapped array
      advanceActualsAndVariances,
      districtAndAreaProgramPairsActuals: districtPairs,
      from: pickDateField(data, ['from', 'fromDate', 'From', 'FromDate', 'fromDateString', 'from_date', 'From_Date']),
      to: pickDateField(data, ['to', 'toDate', 'To', 'ToDate', 'toDateString', 'to_date', 'To_Date'])
    };

    console.log('API data keys:', Object.keys(data || {}));
    console.log('picked mapped.from =>', mapped.from, ' mapped.to =>', mapped.to);

    setSurrender(mapped);

    setLocal({
      from: formatDateForInput(mapped.from),
      to: formatDateForInput(mapped.to),
      numberOfClientsAchieved: mapped.numberOfClientsAchieved ?? "",
      country: mapped.country ?? "",
      districtPairs: (mapped.districtAndAreaProgramPairsActuals || []).map(p => ({ ...p })),
      costDriverActuals: (mapped.costDriverActuals || []).map(cd => ({
        id: cd.id ?? null,
        costDriverNumber: cd.costDriverNumber ?? null,
        costDriver: cd.costDriver ?? "",
        customCostDriver: cd.customCostDriver ?? "",
        isCustom: cd.isCustom ?? false,
        quantity: cd.quantity ?? "",
        unitPrice: cd.unitPrice ?? "",
        actualSpent: cd.actualSpent ?? "",
        attachmentType: cd.attachmentType ?? "physical",
        selectedFiles: [],
        supportDocuments: cd.supportDocuments || [],
        justification: cd.justification || "",
        reasonForVariance: cd.reasonForVariance || "", // ADDED THIS LINE
        isNew: !!cd.isNew,
        isNewInReview: !!cd.isNewInReview
      }))
    });

  } catch (err) {
    console.error("Error fetching surrender:", err);
    setError(err?.message || "Error fetching surrender");
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const fetchReviewers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/users/reviewers`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setReviewers(response.data);
      } catch (error) {
        console.error("Error fetching reviewers:", error);
      }
    };
    
    fetchReviewers();
  }, []);

useEffect(() => {
  fetchSurrenderData();
}, [requisitionID]);


  useEffect(() => {
    const fetchRequisitionDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisitionID}`
        );
  
        const data = response.data;
        setRequisition(data);
  
        const districtPairs = Array.isArray(data.districtAndAreaProgramPairs)
          ? data.districtAndAreaProgramPairs
          : [];
  
        setSurrenderFormData({
          districtAndAreaProgramPairs: districtPairs.map(pair => ({
            district: pair.district,
            areaProgram: pair.areaProgram,
          })),
        });
  
        const costDrivers = Array.isArray(data.costDrivers)
          ? data.costDrivers
          : [];
  
        setCostDriversData(
          costDrivers.map(driver => ({
            costDriver: driver.costDriver,
            quantity: "", 
            unitPrice: "", 
            actualSpent: driver.actualSpent || "",
            selectedFiles: [],
          }))
        );
  
        setCostDriverActuals(
          costDrivers.map(driver => ({
            costDriver: driver.costDriver,
            quantity: "", 
            unitPrice: "", 
            actualSpent: driver.actualSpent || "",
            selectedFiles: [],
          }))
        );
  
       
  
        if (data.from && data.to) {
          const fromDate = new Date(data.from);
          const toDate = new Date(data.to);
  
          const localFromDate = new Date(
            fromDate.getTime() - fromDate.getTimezoneOffset() * 60000
          ).toISOString().split("T")[0];
  
          const localToDate = new Date(
            toDate.getTime() - toDate.getTimezoneOffset() * 60000
          ).toISOString().split("T")[0];
  
          setFrom(localFromDate);
          setTo(localToDate);
  
          if (districtPairs.length > 0) {
            setSurrenderFormData({
              districtAndAreaProgramPairs: districtPairs.map(pair => ({
                district: pair.district,
                areaProgram: pair.areaProgram,
              })),
            });
          }
        }
      } catch (error) {
        console.error("Error fetching requisition details:", error);
      }
    };
  
    fetchRequisitionDetails();
  }, [requisitionID]);


  useEffect(() => {
    if (!reviewerOptions || reviewerOptions.length === 0) return;
    const target = reviewerOptions.find(r => r.reviewerNumber === currentReviewerNumber + 1);
    setNextReviewerId(target ? target.value : (reviewerOptions[0]?.value ?? ""));
  }, [reviewerOptions, currentReviewerNumber]);


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/users`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    
    fetchUsers();
  }, []);
  
  useEffect(() => {
    if (users.length === 0) return;
  
    const allowedTypes = ["Reviewer", "Surrender Reviewer"];
    const filtered = users.filter(user => 
      allowedTypes.includes(user.userType) && 
      user.id !== currentUser.id
    );
    
    setReviewers(filtered);
  }, [users, currentUser.id]);
  

  
if (loading) return <div>Loading surrender data...</div>;
  if (error) return <div>Sorry an Error has occured. {error}</div>;
  if (!surrender || !local) return <div>Loading…</div>;

  const handleModalClose = () => {
        
    navigate('/notifications');
  };
  const handleErrorModalClose = () => {
    setShowErrorModal(false);
  };
  
  const handleNoInternetModalClose = () => {
    console.log("Closed No Internet modal");
    setShowNoInternetModal(false);
  };
  const getSupportDocuments = (costDriverName) => supportDocumentsMap[costDriverName] ?? supportDocumentsMap.default;
  const getDefaultUnitPrice = (costDriverName) => {
    return 0;
  };

  const addDistrictPairLocal = () => setLocal(l => ({ ...l, districtPairs: [...(l.districtPairs || []), { district: "", areaProgram: "" }] }));
  const removeDistrictPairLocal = (idx) => setLocal(l => ({ ...l, districtPairs: l.districtPairs.filter((_, i) => i !== idx) }));
  const handleLocalDistrictChange = (index, selectedOption) => {
    setLocal(prev => {
      const arr = [...(prev.districtPairs || [])];
      arr[index] = { ...arr[index], district: selectedOption ? selectedOption.value : "" };
      return { ...prev, districtPairs: arr };
    });
  };
  const handleLocalAreaProgramChange = (index, value) => {
    setLocal(prev => {
      const arr = [...(prev.districtPairs || [])];
      arr[index] = { ...arr[index], areaProgram: value };
      return { ...prev, districtPairs: arr };
    });
  };

  const handleCostDriverSelectChange = (index, selectedOption) => {
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      if (!selectedOption) {
        arr[index] = { ...arr[index], costDriver: "", isCustom: false, customCostDriver: "", supportDocuments: getSupportDocuments(""), unitPrice: "" };
      } else if (selectedOption.value === "Other") {
        arr[index] = { ...arr[index], costDriver: "", isCustom: true, customCostDriver: "", supportDocuments: "", unitPrice: "" };
      } else {
        arr[index] = { ...arr[index], costDriver: selectedOption.value, isCustom: false, customCostDriver: "", supportDocuments: getSupportDocuments(selectedOption.value), unitPrice: getDefaultUnitPrice(selectedOption.value) };
      }
      return { ...prev, costDriverActuals: arr };
    });
  };

  

  const handleCustomCostDriverChange = (index, value) => setLocal(prev => { const arr = [...(prev.costDriverActuals || [])]; arr[index] = { ...arr[index], customCostDriver: value }; return { ...prev, costDriverActuals: arr }; });

  const handleLocalInputChange = (index, field, value) => {
    setLocal(prev => {
      const updated = [...prev.costDriverActuals];
      const item = { ...updated[index] };
  
      if (['quantity', 'unitPrice', 'actualSpent'].includes(field)) {
        const numValue = value === "" ? "" : Number(value);
        item[field] = numValue;
  
        if (field === 'quantity' && item.unitPrice) {
          item.actualSpent = (numValue * item.unitPrice) || 0;
        } 
        else if (field === 'unitPrice' && item.quantity) {
          item.actualSpent = (item.quantity * numValue) || 0;
        }
        else if (field === 'actualSpent' && item.unitPrice) {
          item.quantity = (numValue / item.unitPrice) || 0;
        }
      } 
      else {
        item[field] = value;
      }
  
      updated[index] = item;
      return { ...prev, costDriverActuals: updated };
    });
  };

  
  const addLocalRow = () => {
    setLocal(prev => {
      const arr = Array.isArray(prev.costDriverActuals) ? [...prev.costDriverActuals] : [];
      arr.push({
        costDriver: "",
        customCostDriver: "",
        isCustom: false,
        quantity: "",
        unitPrice: "",
        actualSpent: "",
        justification: "",
        reasonForVariance: "",
        supportDocuments: [], 
        attachmentType: "physical",
        selectedFiles: [],
        isNew: true,
        isNewInReview: true 
      });

      // ✅ ADD THIS DEBUG LOG:
    console.log("=== DEBUG: New row added with isNewInReview:", true);

      return { ...prev, costDriverActuals: arr };
    });
  };

  const removeLocalRow = (index) => setLocal(prev => ({ ...prev, costDriverActuals: [...(prev.costDriverActuals || [])].filter((_, i) => i !== index) }));

  const handleReasonForVarianceChange = (index, value) => {
    // Update the local state for display
    setLocal(prev => {
      const updated = [...prev.costDriverActuals];
      updated[index] = {
        ...updated[index],
        reasonForVariance: value
      };
      return { ...prev, costDriverActuals: updated };
    });
  };
  const handleSupportDocumentsCheckboxChange = (index, attachmentType) => {
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      arr[index] = { ...arr[index], attachmentType };
      if (attachmentType === "physical") arr[index].selectedFiles = [];
      return { ...prev, costDriverActuals: arr };
    });
  };

  const handleFileChange = (index, event) => {
    const files = Array.from(event.target.files || []);
    const valid = files.filter(f => f.type === "application/pdf");

    // ✅ ADD THESE DEBUG LOGS:
  console.log("=== DEBUG: handleFileChange called", {
    index,
    totalFiles: files.length,
    validPDFs: valid.length,
    fileNames: files.map(f => f.name)
  });
    
    if (valid.length !== files.length) {
      setPopupMessage("Only PDF files are allowed.");
      setShowPopup(true);
      event.target.value = "";
      return;
    }
  
    setLocal(prev => {
      const arr = [...(prev.costDriverActuals || [])];
      const existing = arr[index].selectedFiles || [];
      
      const duplicates = valid.filter(newFile => 
        existing.some(existingFile => 
          existingFile.name === newFile.name && 
          existingFile.size === newFile.size
        )
      );
  
      if (duplicates.length > 0) {
        setDuplicateFilePopup({
          show: true,
          duplicateFileName: duplicates[0].name
        });
        event.target.value = "";
        return prev;
      }
  
      arr[index] = { 
        ...arr[index], 
        selectedFiles: [...existing, ...valid] 
      };

      // ✅ ADD THIS DEBUG LOG TOO:
    console.log("=== DEBUG: Files added to state for row", index, {
      newFiles: valid.map(f => f.name),
      totalFilesNow: arr[index].selectedFiles.length
    }); 
      return { ...prev, costDriverActuals: arr };
    });
    
    event.target.value = "";
  };

  const closePopup = () => { setShowPopup(false); setPopupMessage(""); };

  const localActualsTotal = (local.costDriverActuals || []).reduce((sum, d) => sum + (Number(d.actualSpent) || 0), 0);
  const advanceTotals = (surrender.advanceActualsAndVariances || []).reduce((sum, item) => {
    const amount = Number(item?.advance) || 0;
    return sum + amount;
  }, 0);
  
  const varianceTotal = (local.costDriverActuals || []).reduce((sum, item, index) => {
    const advance = index < (surrender.advanceActualsAndVariances?.length || 0)
      ? Number(surrender.advanceActualsAndVariances[index]?.advance) || 0
      : 0;
    
    const actual = Number(item?.actualSpent) || 0;
    return sum + (advance - actual);
  }, 0);

  const totalVariance = Number(varianceTotal || 0);
  const EPS = 0.005; 
  const isZeroVariance = Math.abs(totalVariance) < EPS;



  const handleNextReviewerClick = async (event) => {
    setIsSubmitting(true);
    try {
      event?.preventDefault?.();
      
      if (!navigator.onLine) {
        setShowNoInternetModal(true);
        return;
      }
      
      if (!reviewData?.nextReviewerId) {
        setShowselectNextReviewerModal(true);
        return;
      }
  
      const token = localStorage.getItem("token") || "";
      const currentUserId = currentUser?.id ?? localStorage.getItem("userId") ?? "";
  
      // Add this debug section before the updatePayload
      console.log("=== DEBUG: Checking reasonForVariance in local.costDriverActuals ===");
      local.costDriverActuals?.forEach((cd, index) => {
        console.log(`Row ${index}:`, {
          costDriver: cd.costDriver,
          reasonForVariance: cd.reasonForVariance,
          isNew: cd.isNew,
          actualSpent: cd.actualSpent
        });
      });

      const updatePayload = {
        RequisitionId: requisitionID,
        StaffName: surrender.staffName || surrender.StaffName,
        StaffLevel: surrender.staffLevel || surrender.StaffLevel,
        SupervisorName: surrender.supervisorName || surrender.SupervisorName,
        From: local.from ? new Date(local.from) : surrender.from,
        To: local.to ? new Date(local.to) : surrender.to,
        ActivityName: surrender.activityName || surrender.ActivityName,
        ActivityPurpose: surrender.activityPurpose || surrender.ActivityPurpose,
        TargetClient: surrender.targetClient || surrender.TargetClient,
        NumberOfClientsAchieved: local.numberOfClientsAchieved ?? surrender.numberOfClientsAchieved,
        ExpectedImpact: surrender.expectedImpact || surrender.ExpectedImpact,
        AchievedImpact: surrender.achievedImpact || surrender.AchievedImpact,
        Country: local.country || surrender.country || surrender.Country,
        HubOffice: surrender.hubOffice || surrender.HubOffice,
        ProjectCode: surrender.projectCode || surrender.ProjectCode,
        ProjectName: surrender.projectName || surrender.ProjectName,
        BudgetLineCode: surrender.budgetLineCode || surrender.BudgetLineCode,
        PayMode: surrender.payMode || surrender.PayMode,
        BankName: surrender.bankName || surrender.BankName,
        BranchName: surrender.branchName || surrender.BranchName,
        BankAccount: surrender.bankAccount || surrender.BankAccount,
        PhoneNumber: surrender.phoneNumber || surrender.PhoneNumber,
        Status: `Reviewed by ${fullName || ""}`,
        NextReviewerId: reviewData.nextReviewerId,
        AdvanceActualsAndVariances: local.costDriverActuals?.map((cd, index) => {
          const advanceRow = surrender.advanceActualsAndVariances?.[index];
          const advance = advanceRow ? Number(advanceRow.advance) || 0 : 0;
          const actualSpent = Number(cd.actualSpent || 0);
          const variance = advance - actualSpent;
          
          // Use the reason from local state if available, otherwise fall back to existing reason from surrender data
          const reasonForVariance = cd.reasonForVariance || advanceRow?.reasonForVariance || "";
          
          return {
            CostDriver: cd.costDriver,
            Advance: advance,
            ActualSpent: actualSpent,
            Variance: variance,
            ReasonForVariance: reasonForVariance
          };
        }),
        CostDriverActuals: local.costDriverActuals?.map(cd => ({
          Id: cd.id,
          CostDriver: cd.costDriver,
          Quantity: cd.quantity,
          UnitPrice: cd.unitPrice,
          ActualSpent: cd.actualSpent,
          AttachmentType: cd.attachmentType,
          Justification: cd.justification || "",
          ReasonForVariance: cd.reasonForVariance || "", 
          IsNew: cd.isNew,
          IsNewInReview: cd.isNewInReview
        })),
        DistrictAndAreaProgramPairs: local.districtPairs?.map(pair => ({
          District: pair.district,
          AreaProgram: pair.areaProgram
        }))
      };
  
      const updateResponse = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/surrender/update`,
        updatePayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
  
      if (updateResponse.status >= 400) {
        throw new Error(`Data update failed: ${updateResponse.statusText}`);
      }
  
      const formData = new FormData();
      let hasFilesToUpload = false;

      console.log("=== DEBUG: Checking files for upload ===");
    console.log("local.costDriverActuals:", local.costDriverActuals);
    
  
      local.costDriverActuals.forEach((cd, index) => {
        console.log(`Row ${index}:`, {
          attachmentType: cd.attachmentType,
          selectedFilesCount: cd.selectedFiles?.length,
          isNewInReview: cd.isNewInReview,
          meetsCondition: cd.attachmentType === 'digital' && cd.selectedFiles?.length > 0 && cd.isNewInReview,
          selectedFiles: cd.selectedFiles?.map(f => f.name) || []
        });
        
        if (cd.attachmentType === 'digital' && cd.selectedFiles?.length > 0 && cd.isNewInReview) {
          cd.selectedFiles.forEach(file => {
            formData.append(`files[${index}]`, file);
            hasFilesToUpload = true;
          });
        }
      });

      console.log("=== DEBUG: Has files to upload?", hasFilesToUpload);

  
if (hasFilesToUpload) {
  console.log("=== DEBUG: Making file upload request...");
  await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/surrender/upload-review-files/${requisitionID}`,
    formData,
    { 
      headers: { 
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data" 
      }
    }
  );
  
  const refreshAfterUpload = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/surrender/${requisitionID}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  setSurrender(refreshAfterUpload.data);
}  
      const statusResponse = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/surrender/update-status`,
        {
          RequisitionID: requisitionID,
          Status: `Reviewed by ${fullName || ""}`,
          NextReviewerId: reviewData.nextReviewerId,
          CurrentReviewerId: currentUserId,
          ReviewersId: currentUserId,
          RequesterID: surrender?.userId ?? surrender?.userID ?? "",
          RequesterName: surrender?.staffName ?? "",
          SendNotificationToNextReviewer: true
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
  
      const refreshResponse = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/surrender/${requisitionID}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      setSurrender(refreshResponse.data);
      setOriginalSurrenderData(refreshResponse.data);
      setShowModal(true);
      setReviewData(prev => ({ ...prev, nextReviewerId: "" }));
      setIsConfirmed(false);
  
    } catch (err) {
      console.error("Submission error:", {
        error: err,
        response: err.response?.data,
        config: err.config
      });
  
      let errorMessage = "Failed to complete all submission steps. ";
      
      if (err.config?.url?.includes('update-status')) {
        errorMessage += "The surrender data was saved successfully, but the status update and notification failed. ";
        errorMessage += "Please notify an administrator to manually update the status.";
      } else {
        errorMessage += "The surrender may not have been saved properly. ";
      }
      
      if (err.response?.data) {
        errorMessage += `Details: ${JSON.stringify(err.response.data)}`;
      } else if (err.message) {
        errorMessage += `Error: ${err.message}`;
      }
  
      alert(errorMessage);
      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }
  }; 
  


  function arraysEqual(arr1, arr2, propsToCompare) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    
    return arr1.every((item1, index) => {
      const item2 = arr2[index];
      return propsToCompare.every(prop => {
        const val1 = typeof item1 === 'object' ? item1[prop] : item1;
        const val2 = typeof item2 === 'object' ? item2[prop] : item2;
        return JSON.stringify(val1) === JSON.stringify(val2);
      });
    });
  }


const handleSurrenderProcessCompleteModalClose = () => {
 setShowSurrenderProcessCompleteModal(false);
};


const handleCompleteNo = () => {
  setHighlightNextLabel(true);
  setShowTooltip(true);

  setTimeout(() => {
    setHighlightNextLabel(false);
    setShowTooltip(false);
  }, 3000);
};

const handleCompleteYes = () => {
  setShowCompleteModal(true);
};

const handleCancelComplete = () => {
  setShowCompleteModal(false);
};

const handleConfirmComplete = async () => {
  if (isCompleting) return;
  setIsCompleting(true);

  try {
    const token = localStorage.getItem("token") || "";
    const currentReviewerId = currentUser?.id ?? currentUserId ?? localStorage.getItem("userId") ?? "";
    
    if (!surrender?.userId && !surrender?.userID) {
      throw new Error("Cannot determine requester ID");
    }

    const payload = {
      RequisitionID: requisitionID,
      Status: "Surrender Review Process Complete",
      NextReviewerId: "", 
      CurrentReviewerId: currentReviewerId,
      ReviewersId: currentReviewerId,
      RequesterID: surrender?.userId ?? surrender?.userID ?? "",
      RequesterName: surrender?.staffName ?? "",
      SendNotificationToNextReviewer: false
    };

    console.log("Sending payload:", payload);
    
    // Use the correct endpoint that exists in your backend
    const url = `${process.env.REACT_APP_API_BASE_URL}/surrender/update-status`;
    const response = await axios.put(url, payload, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json"
      }
    });

    if (response && response.status >= 200 && response.status < 300) {
      setShowCompleteModal(false);
      setShowSurrenderProcessCompleteModal(true);
      await fetchSurrenderData();
    } else {
      const msg = response?.data ? JSON.stringify(response.data) : `Server returned ${response?.status}`;
      throw new Error(msg);
    }
  } catch (err) {
    console.error("Error. Try Again or Ask for Support:", err); 
    alert(`Error. Check your internet connection and try Again or Ask for Support`); //Failed to mark surrender complete
    console.log("Error. Try Again or Ask for Support:", err.message); 
  } finally {
    setIsCompleting(false);
  }
};







  return (
    <div id="wrapper">
      <LoadingOverlay isVisible={isSubmitting} />
      <Sidebar userType={theUserType} />

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3"><i className="fa fa-bars" /></button>

            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append"><button className="btn btn-primary" type="button"><i className="fas fa-search fa-sm" /></button></div>
              </div>
            </form>

            <ul className="navbar-nav ml-auto"><TopBarIcons /></ul>
          </nav>

          <div className="container-fluid">
            <div className="view-requisition-header">
              <Link className="nav-link" to="/surrenders"><i className="fas fa-arrow-left back-button" /></Link>
              <h1 className="h3">Review Surrender</h1>
            </div>

            <div className="buttons-container">
              <PrintSurrenderButton targetId="printable-area" buttonLabel="Print Surrender" />
              <ExportExcelButton formArray={[]} setFormArray={() => {}} currentFormData={{}} fileName="SurrenderReview.xlsx" />
              <ExportPDFButton contentRef={contentRef} />
            </div>

            <div id="printable-area" ref={contentRef} style={{ padding: '20px' }}>
              <form>
                <div className="requisition-details">
                  <div className="view-requisition-date-and-id" id="status" hidden>
                    <div>
                      <label><strong>Surrender Date: </strong></label>
                      <input type="text" value={surrender?.surrenderDateString ? DateTime.fromISO(surrender.surrenderDateString).toFormat('dd/MM/yyyy') : ''} readOnly  />
                    </div>
                    <p><strong>Requisition ID:</strong> {surrender?.requisitionID}</p>
                  </div>

                  <div className="staff-activity-container">
                    <div className="form-group">
                      <h3>Staff Details</h3>
                      <div className="form-field"><label>Staff Name:</label><input type="text" value={surrender?.staffName || ''} readOnly className="read-only" /></div>
                    </div>

                    <div className="form-group">
                        <h3>Activity Details</h3>
                      <div className="form-field">
                      <div className="field-container">
                      <label>From:</label>
                        <input
                          type="date"
                          name="from"
                          value={local.from || ""}
                          onChange={(e) => setLocal(l => ({ ...l, from: e.target.value }))}
                        />
                        <label>To:</label>
                        <input
                          type="date"
                          name="to"
                          value={local.to || ""}
                          onChange={(e) => setLocal(l => ({ ...l, to: e.target.value }))}
                        />
                      </div>



                      </div>     
                                       
                        

                      <br />
                      <div className="form-field"><label>Activity Name:</label><input type="text" value={surrender?.activityName || ''} readOnly className="read-only" /></div>

                      <div className="form-field">
                        <label>Activity Purpose:</label>
                        <input type="text" value={surrender?.activityPurpose || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Target Client:</label>
                        <input type="text" value={surrender?.targetClient || ''} readOnly className="read-only" />
                      </div>

                      <div className="form-field">
                        <label>Number of Clients Achieved:</label>
                        <input value={local.numberOfClientsAchieved} onChange={e => setLocal(l => ({ ...l, numberOfClientsAchieved: Number(e.target.value) }))} />
                      </div>
                    
                      <div className="form-field">
                        <label>Expected Impact:</label>
                        <input type="text" value={surrender?.expectedImpact || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Achieved Impact:</label>
                        <input type="text" value={surrender?.achievedImpact || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label><strong>BTO Report:</strong></label>
                        {surrender?.btoReportPath ? (
                          <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginTop: "0.25rem",
                            }}
                          >
                            <a
                              href={`${process.env.REACT_APP_API_BASE_URL}/surrender/view-bto/${surrender.requisitionID}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              title="View BTO Report"
                            >
                              {surrender.btoReportPath.split("/").pop()}
                            </a>
                            
                          </div>
                        ) : (
                          <p style={{ fontStyle: "italic", color: "#666" }}>No BTO Report uploaded.</p>
                        )}
                      </div>

                      <div className="form-field">
                      <label>Country:</label>
                      <input
                        type="text"
                        value={local.country || ''}
                        onChange={e => setLocal(l => ({ ...l, country: e.target.value }))}
                      />
                      </div>

                      <h3>District and Area Program</h3>
                      <div className="district-area-container">
                        {local.districtPairs && local.districtPairs.length > 0 ? (
                          local.districtPairs.map((pair, idx) => (
                            <div key={idx} className="field-container">
                              <div className="form-field">
                                <label>District:</label>
                                <Select options={districtOptions} value={districtOptions.find(o => o.value === pair.district) || null} isClearable onChange={(opt) => handleLocalDistrictChange(idx, opt)} className="custom-select-control" />
                              </div>

                              <div className="form-field">
                                <label>Area Program:</label>
                                <input type="text" value={pair.areaProgram || ""} onChange={e => handleLocalAreaProgramChange(idx, e.target.value)} />
                              </div>

                              {idx === 0 ? <button type="button" className="add-button" onClick={addDistrictPairLocal}>+</button> : <button type="button" className="remove-button" onClick={() => removeDistrictPairLocal(idx)}>X</button>}
                            </div>
                          ))
                        ) : (
                          <div className="field-container">
                            <div className="form-field"><label>District:</label><Select options={districtOptions} value={null} isDisabled className="custom-select-control" /></div>
                            <div className="form-field"><label>Area Program:</label><input type="text" value="" readOnly className="read-only" /></div>
                          </div>
                        )}
                      </div>
                      <div className="form-field">
                        <label>Hub Office:</label>
                        <input type="text" value={surrender?.hubOffice || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Status:</label>
                        <input type="text" value={surrender?.status || ''} readOnly className="read-only" />
                      </div>
                    </div>


<div className="form-group">
                      <h3>Project & Advance Details</h3>
                      <div className="form-field">
                        <label>Project Code:</label>
                        <input type="text" value={surrender?.projectCode || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Project Name:</label>
                        <input type="text" value={surrender?.projectName || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Budget Line Code:</label>
                        <input type="text" value={surrender?.budgetLineCode || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Pay Mode:</label>
                        <input type="text" value={surrender?.payMode || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Bank Name:</label>
                        <input type="text" value={surrender?.bankName || ''} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Account Number:</label>
                        <input 
                          type="text" 
                          value={surrender?.bankAccount || ''} 
                          readOnly 
                          className="read-only" 
                        />
                      </div>
                      <div className="form-field">
                        <label>Phone Number:</label>
                        <input type="text" value={surrender?.phoneNumber || ''} readOnly className="read-only" />
                      </div>
                    </div>
                  




                    
                  </div>
                  

                  <div className="details-group">
                    <div id="cost-drivers-wrapper">
                      <h3>Cost Drivers - Actuals</h3>
                      <table className="table-bordered">
                        <thead>
                          <tr>
                            <th>Cost Driver</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Actual Spent</th>
                            <th>Support Documents</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                        {Array.isArray(local.costDriverActuals) &&
                          local.costDriverActuals.map((item, index) => {
                            const isNewRow = item.isNewInReview || item.isNew;
                            const hasDocuments = item.supportDocuments?.length > 0;
                            const isOriginalRowWithDocs = !item.isNew && hasDocuments;
                            const isNewRowWithDocs = item.isNew && hasDocuments;
                            const isNewRowWithoutDocs = item.isNew && !hasDocuments;

                            return (
                              <tr key={index} className={item.isNew ? "new-row" : ""}>
                                <td>
                                  {item.isCustom ? (
                                    <input
                                      type="text"
                                      value={item.costDriver}
                                      onChange={(e) => handleCustomCostDriverChange(index, e.target.value)}
                                      className="form-control"
                                      placeholder="Type the Cost Driver"
                                    />
                                  ) : (
                                    <div className="dropdown-wrapper">
                                      {item.isNew && <span className="over-expenditure-text">Additional Cost Driver </span>}
                                      <select
                                        value={item.costDriver}
                                        onChange={(e) => handleLocalInputChange(index, "costDriver", e.target.value)}
                                        className="form-control cost-driver-dropdown"
                                      >
                                        <option value="">Select Cost Driver</option>
                                        <option value="FCI Staff Perdiem">FCI Staff Perdiem</option>
                                        <option value="Partners DSA">Partners DSA</option>
                                        <option value="Government Staff DSA -AEDC, AEDO LVCDO">Government Staff DSA -AEDC, AEDO LVCDO</option>
                                        <option value="Field Staff DSA">Field Staff DSA</option>
                                        <option value="Venue/Hall Hire">Venue/Hall Hire</option>
                                        <option value="Snacks">Snacks</option>
                                        <option value="Refreshments">Refreshments</option>
                                        <option value="Lunch Allowance">Lunch Allowance</option>
                                        <option value="Transport Refund">Transport Refund</option>
                                        <option value="Stationery">Stationery</option>
                                        <option value="Scanning, printing & photocopy">Scanning, printing & photocopy</option>
                                        <option value="Training Materials">Training Materials</option>
                                        <option value="PA System hire">PA System hire</option>
                                        <option value="Genset Hire">Genset Hire</option>
                                        <option value="Vehicle Hire">Vehicle Hire</option>
                                        <option value="Vehicle Fuel">Vehicle Fuel</option>
                                        <option value="Toll Gate Fee">Toll Gate Fee</option>
                                        <option value="Other">Other</option>
                                      </select>
                                    </div>
                                  )}
                                  
                                  {(item.isNew || isNewRow) && (
                                    <div className="mt-2">
                                      <label className="d-block">Justification:</label>
                                      {item.isNew ? (
                                        <input
                                          type="text"
                                          className="form-control justification-input"
                                          value={item.justification || ''}
                                          onChange={(e) => handleLocalInputChange(index, 'justification', e.target.value)}
                                          placeholder="Enter justification"
                                        />
                                      ) : (
                                        <div className="saved-justification">
                                          {item.justification || "No justification provided"}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </td>

                                <td>
                                  <input
                                    value={item.quantity ?? ""}
                                    onChange={(e) => handleLocalInputChange(index, 'quantity', e.target.value)}
                                    className="form-control"
                                  />
                                </td>

                                <td>
                                  <input
                                    value={formatCurrency(item.unitPrice)}
                                    onChange={(e) => {
                                      const raw = e.target.value.replace(/[^0-9.]/g, '');
                                      handleLocalInputChange(index, 'unitPrice', raw);
                                    }}
                                    className="form-control"
                                  />
                                </td>

                                <td>
                                  <input
                                    value={formatCurrency(item.actualSpent)}
                                    onChange={(e) => {
                                      const raw = e.target.value.replace(/[^0-9.]/g, '');
                                      handleLocalInputChange(index, 'actualSpent', raw);
                                    }}
                                    className="form-control"
                                  />
                                </td>
                                <td>
                        {item.supportDocuments?.length > 0 ? (
                          item.supportDocuments.map(doc => (
                            <div key={doc.id} className="d-flex align-items-center gap-2 mb-1">
                              <a href={`${process.env.REACT_APP_API_BASE_URL}/files/view/${doc.id}`} target="_blank" rel="noopener noreferrer">
                                View
                              </a>
                              <a href={`${process.env.REACT_APP_API_BASE_URL}/files/${doc.id}`} download>
                                Download
                              </a>
                            </div>
                          ))
                        ) : item.isNewInReview ? (
                          <>
                            <label className="d-block">
                              <input
                                type="checkbox"
                                checked={item.attachmentType === "physical"}
                                onChange={() => handleSupportDocumentsCheckboxChange(index, "physical")}
                                className="the-checkbox-input"
                              />
                              Physical attachments
                            </label>
                            <label className="d-block">
                              <input
                                type="checkbox"
                                checked={item.attachmentType === "digital"}
                                onChange={() => handleSupportDocumentsCheckboxChange(index, "digital")}
                                className="the-checkbox-input"
                              />
                              Digital attachments
                            </label>
                            {item.attachmentType === "digital" && (
                            <>
                              <div className="custom-file-input-container mt-2">
                                <label className="custom-file-input-label">
                                  <input
                                    type="file"
                                    className="hidden-file-input"
                                    accept="application/pdf"
                                    multiple
                                    onChange={(e) => handleFileChange(index, e)}
                                  />
                                  <span className="custom-file-text">Choose Files</span>
                                  <span className="plus-symbol">+</span>
                                </label>
                              </div>
                              
                              {/* ADD THIS SECTION TO DISPLAY SELECTED FILES */}
                              {item.selectedFiles && item.selectedFiles.length > 0 && (
                                <div className="selected-files mt-2">
                                  <b>Selected Files:</b>
                                  <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                    {item.selectedFiles.map((file, fileIndex) => (
                                      <li key={fileIndex} style={{ fontSize: '0.9rem', marginBottom: '4px' }}>
                                        {file.name}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </>
                          )}
                          </>
                        ) : (
                          <span>Has physical attachments</span>
                        )}
                      </td>

                                <td>
                                  {item.isNew && (
                                    <button
                                      type="button"
                                      className="btn btn-danger delete"
                                      onClick={() => removeLocalRow(index)}
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="3" style={{ textAlign: 'right' }}><b>Totals:</b></td>
                            <td>{formatCurrency(localActualsTotal)}</td>
                            <td colSpan="2"></td>
                          </tr>
                        </tfoot>
                      </table>

                      <button type="button" className="round-button" onClick={addLocalRow}><i className="fas fa-plus" /></button>
                    </div>
                  </div>

                  <div className="details-group">
                    <div id="advance-variance-wrapper">
                      <h3>Advance, Actuals & Variance</h3>
                      <table className="table-bordered">
                        <thead><tr><th>Cost Driver</th><th>Advance</th><th>Actual Spent</th><th>Variance</th><th>Reason for Variance</th></tr></thead>
                        <tbody>
                          {local.costDriverActuals.map((cDriver, idx) => {
                            const advanceRow = (surrender.advanceActualsAndVariances || [])[idx] || {};
                            const advance = Number(advanceRow.advance || 0);
                            const costDriverLabel = cDriver.costDriver || cDriver.customCostDriver || advanceRow.costDriver || "";
                            const actualSpent = Number(cDriver.actualSpent || 0);
                            const variance = advance - actualSpent;
                            const isNew = !!cDriver.isNew;

                             // Determine if the reason field should be editable
                             const hasVariance = Math.abs(variance) > 0.005; // Using EPS for consistency
                             const isEditable = hasVariance;

                             // Enhanced debug logging
                            console.log(`=== DEBUG Row ${idx} ===`);
                            console.log('advanceRow object:', advanceRow);
                            console.log('All keys in advanceRow:', Object.keys(advanceRow));
                            console.log('Cost Driver:', costDriverLabel);
                            
                            // Add this inside the map function to check both arrays
                        console.log('costDriverActuals at same index:', local.costDriverActuals[idx]);
                        console.log('Does costDriverActuals have reason?', local.costDriverActuals[idx]?.reasonForVariance);

                        const reasonForVariance = cDriver.reasonForVariance || advanceRow.reasonForVariance || "";                             console.log(`Reason for variance for row ${idx}:`, reasonForVariance);
                            return (
                              <tr key={`adv-${idx}`} className={isNew ? "new-row" : ""}>
                                <td><strong>{idx + 1}. </strong><input type="text" value={costDriverLabel} readOnly className="read-only" /></td>
                                <td><input type="text" value={formatCurrency(advance)} readOnly className="read-only" /></td>
                                <td><input type="text" value={formatCurrency(actualSpent)} readOnly className="read-only" /></td>
                                <td><input type="text" value={formatCurrency(variance)} readOnly className="read-only" /></td>
                                <td>
                                  <input
                                    type="text"
                                    className={`form-control ${isEditable ? 'editable-variance-reason' : 'read-only'}`}
                                    placeholder={isEditable ? "Type the reason for variance" : "N/A (No variance)"}
                                    value={reasonForVariance} 
                                    onChange={(e) => handleReasonForVarianceChange(idx, e.target.value)}
                                    readOnly={!isEditable}
                                    disabled={!isEditable}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>

                        <tfoot>
                          <tr>
                            <td style={{ textAlign: "right" }}><b>Totals:</b></td>
                            <td>{formatCurrency(advanceTotals)}</td>
                            <td>{formatCurrency(localActualsTotal)}</td>
                            <td>{formatCurrency(varianceTotal)}</td>
                          </tr>
                        </tfoot>
                      </table>

                      {theUserType === "Surrender Reviewer" && (
                        <div className="variance-summary">
                          {totalVariance > EPS && (
                            <p>
                              <i>According to the above,</i> <br />
                              {surrender?.staffName || "The submitter"} has{" "}
                              <strong>{formatCurrencyForSecondTable(totalVariance)}</strong> remaining.
                              <br />
                              <br />
                              Please cross-check and confirm. <br />
                            </p>
                          )}
                          {totalVariance < -EPS && (
                            <p>
                              <i>According to the above,</i> <br />
                              {surrender?.staffName || "The submitter"} has overspent by{" "}
                              <strong>{formatCurrencyForSecondTable(Math.abs(totalVariance))}</strong>.
                              <br />
                              <br />
                              Please cross-check and confirm. <br />
                            </p>
                          )}
                          {isZeroVariance && (
                            <p>
                              <i>According to the above,</i> <br />
                              {surrender?.staffName || "The submitter"} has spent all the money that was
                              advanced to him/her, which implies that he/she doesn't owe any money to the
                              office and the office doesn't owe any money to him/her. <br />
                              <br />
                              Please cross-check and confirm. <br />
                            </p>
                          )}
                        </div>
                      )}


                    <div className="submitted-by-section" style={{ marginTop: 8, marginBottom: 12 }}>
                      <h4>Submitted by:</h4>
                      
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 120 }}>
                          {(
                            surrender?.submitterSignaturePath ||
                            surrender?.submitterSignatureFilePath ||
                            surrender?.signatureFilePath ||
                            surrender?.staffSignatureFilePath ||
                            surrender?.staffSignaturePath
                          ) ? (
                            <img
                              src={
                                (surrender?.submitterSignaturePath || surrender?.submitterSignatureFilePath ||
                                surrender?.signatureFilePath || surrender?.staffSignatureFilePath || surrender?.staffSignaturePath
                                ).toString().startsWith("http")
                                  ? (surrender?.submitterSignaturePath || surrender?.submitterSignatureFilePath ||
                                    surrender?.signatureFilePath || surrender?.staffSignatureFilePath || surrender?.staffSignaturePath)
                                  : `${process.env.REACT_APP_STATIC_BASE_URL}/${(surrender?.submitterSignaturePath || surrender?.submitterSignatureFilePath ||
                                    surrender?.signatureFilePath || surrender?.staffSignatureFilePath || surrender?.staffSignaturePath)}`
                              }
                              alt={`${surrender?.staffName || 'Submitter'} signature`}
                              style={{
                                width: 120,
                                height: 60,
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            <div style={{ width: 120, height: 60, display: "flex", justifyContent: "center", alignItems: "center", color: "#999", border: "1px dashed #ddd" }}>
                              No signature
                            </div>
                          )}

                          {/* name below signature */}
                          <div style={{ marginTop: 8, fontSize: "0.95rem", textAlign: "center", fontWeight: 500 }}>
                            {surrender?.staffName ||
                            surrender?.requesterName ||
                            surrender?.submittedBy ||
                            surrender?.userName ||
                            "----"}
                          </div>

                          {/* FIXED: Use surrenderDateString (lowercase 's') */}
                          <div style={{ fontSize: "0.85rem", color: "#666", marginTop: 4 }}>
                            {surrender?.surrenderDateString 
                              ? DateTime.fromISO(surrender.surrenderDateString).toFormat('dd LLL yyyy') 
                              : "No date"}
                          </div>
                        </div>
                      </div>
                    </div>

                   
                    <div className="reviewed-by-section" style={{ marginTop: 20 }}>
                    <h4>Reviewed by:</h4>
                    <br/>

                    <div className="reviewed-by-list" style={{ display: "flex", gap: 20, alignItems: "flex-end", flexWrap: "wrap" }}>
                      {(surrender.reviewHistory || []).length === 0 ? (
                        <div style={{ color: "#666" }}> ---- <br/><br/></div>
                      ) : (
                        (surrender.reviewHistory || []).map((h) => (
                          <div key={h.id} className="reviewer-item" style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 120 }}>
                            {h.signatureFilePath ? (
                              <img
                                src={
                                  h.signatureFilePath.toString().startsWith("http") 
                                    ? h.signatureFilePath 
                                    : `${process.env.REACT_APP_STATIC_BASE_URL}/${h.signatureFilePath.replace(/^\//, '')}`
                                }
                                alt={`${h.fullName} signature`}
                                style={{ 
                                  width: 120, 
                                  height: 60, 
                                  objectFit: "contain", 
                                  border: "none",
                                  padding: 0,
                                  background: "transparent",
                                  display: "block"
                                }}
                                onError={(e) => {
                                  console.error("Failed to load reviewer signature:", h.signatureFilePath);
                                  e.target.style.display = 'none';
                                  const fallback = e.target.parentNode.querySelector('.reviewer-signature-fallback');
                                  if (fallback) fallback.style.display = 'flex';
                                }}
                              />
                            ) : (
                              <div style={{ 
                                width: 120, 
                                height: 60, 
                                display: "flex", 
                                justifyContent: "center", 
                                alignItems: "center", 
                                color: "#999", 
                                border: "1px dashed #ddd",
                                fontSize: "0.8rem",
                                textAlign: "center",
                                fontWeight: 500
                              }}>
                                No signature
                              </div>
                            )}
                            
                            {/* Fallback for when image fails to load */}
                            <div 
                              className="reviewer-signature-fallback"
                              style={{ 
                                width: 120, 
                                height: 60, 
                                display: "none", 
                                justifyContent: "center", 
                                alignItems: "center", 
                                color: "#999", 
                                border: "1px dashed #ddd",
                                fontSize: "0.8rem",
                                textAlign: "center"
                              }}
                            >
                              Signature not found
                            </div>
                            
                            <div style={{ marginTop: 8, fontSize: "0.95rem", textAlign: "center", fontWeight: 500}}>
                              {h.fullName}
                            </div>
                            
                            <div style={{ fontSize: "0.85rem", color: "#666", marginTop: 4 }}>
                              {h.reviewedAt 
                                ? DateTime.fromISO(h.reviewedAt).toFormat('dd LLL yyyy') 
                                : "No date"}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>




                  
                  <div className="review-section">
                    {/* Confirmation Checkbox */}
                    <div className="checkbox-container">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={isConfirmed}
                          onChange={() => setIsConfirmed(prev => !prev)}
                          className="checkbox"
                        />
                        I confirm that I have reviewed this surrender.
                      </label>
                    </div>

                    {isConfirmed && (
                      <div className="signature-container">
                        <div className="signed-by-label">Signed by:</div>
                        <img
                          src={`${process.env.REACT_APP_STATIC_BASE_URL}/${signatureFilePath}`}
                          alt="User Signature"
                          className="signature-image"
                        />
                        <div className="user-full-name">{fullName}</div>
                        <br />

                        <div className="form-group horizontal-group">
                          <label
                            htmlFor="nextReviewerId"
                            className="form-label"
                            style={{
                              transition: "box-shadow 200ms ease, background-color 200ms ease",
                              padding: 6,
                              borderRadius: 4,
                              ...(highlightNextLabel ? { boxShadow: "0 0 0 3px rgba(59,130,246,0.25)", backgroundColor: "#f0f8ff" } : {})
                            }}
                          >
                            Next Reviewer:
                          </label>

                          <div style={{ position: "relative", display: "inline-block" }}>
                            <select
                              name="nextReviewerId"
                              id="nextReviewerId"
                              value={reviewData.nextReviewerId}
                              onChange={(e) => setReviewData(prev => ({ ...prev, nextReviewerId: e.target.value }))}
                              className="custom-select-field"
                              style={{ minWidth: 280, marginLeft: 8 }}
                            >
                              <option value="" disabled>Select Next Reviewer</option>
                              {reviewers.map(reviewer => (
                                <option key={reviewer.id} value={reviewer.id}>
                                  {reviewer.firstName} {reviewer.lastName}
                                </option>
                              ))}
                            </select>

                            {/* tooltip below the select */}
                            {showTooltip && (
                              <div
                                className="tooltip"
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 8,
                                  marginTop: 6,
                                  padding: "6px 10px",
                                  fontSize: 13,
                                  borderRadius: 6,
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.12)"
                                }}
                              >
                                Send it to the next reviewer
                              </div>
                            )}
                          </div>

                          <button onClick={handleNextReviewerClick} className="btn-send" style={{ marginLeft: 12 }}>
                            Send <i className="fas fa-arrow-right ml-1"></i>
                          </button>
                        </div>

                        <br/>

                        {isSurrenderReviewer && (
                          <div style={{ marginTop: 12 }}>
                            <p>Have all the Reviewers reviewed this Surrender?</p>

                            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCompleteYes}
                              >
                                Yes
                              </button>

                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={handleCompleteNo}
                              >
                                No
                              </button>
                            </div>

                          </div>
                        )}

                        
                        <br/><br/><br/>
                      </div>
                    )}
                  </div>




                    </div>
                  </div>
                </div>
              </form>

              <PopupModal
                title="Reviewed"
                titleStyle = "success-title"
                message="This surrender has been reviewed and sent to the next reviewer"
                icon={faCheckCircle}
                isVisible={showModal}
                onClose={handleModalClose}
                iconBorder="popup-modal-icon"
              />

              <PopupModal
                title="Error"
                titleStyle = "error-title"
                message="An error has occured. If the error persists, kindly ask for support"
                icon={faTimesCircle}
                iconColor="red"
                isVisible={showErrorModal}
                onClose={handleErrorModalClose}
                iconBorder="x-icon"
              />
              
              <PopupModal
                title="No Internet Connection"
                message="Please check your internet connection and try again."
                icon={faWifi}
                isVisible={showNoInternetModal}
                onClose={handleNoInternetModalClose}
                iconBorder="x-icon"
              /> 

              <PopupModal
                title="Who is the next reviewer?"
                titleStyle="error-title"
                message="Please select the next reviewer and then click the Send button."
                icon={faQuestionCircle}
                isVisible={showselectNextReviewerModal}
                onClose={() => {
                  setShowselectNextReviewerModal(false);
                }}
                iconBorder="popup-modal-icon"
               />
              


              
              <PopupModal
                title="Surrender Process Complete"
                titleStyle = "success-title"
                message="The one who submitted the surrender has been notified. If they are supposed to return money, please send them the account details"
                icon={faCheckCircle}
                isVisible={showSurrenderProcessCompleteModal}
                onClose={handleSurrenderProcessCompleteModalClose}
                iconBorder="popup-modal-icon"
              />
              

              <CustomPopupModal
                isVisible={showCompleteModal}
                onClose={handleCancelComplete}
                title="Please Confirm"
                message="Have all the reviewers reviewed this surrender?"  
              >
                <button onClick={handleConfirmComplete} className="btn-primary btn-yes">Yes</button>
                <button onClick={handleCancelComplete} className="btn-no">Cancel</button>
              </CustomPopupModal>

              {showPopup && (
                <PopupModal
                  isVisible={showPopup}
                  onClose={closePopup}
                  title="Notice"
                  message={popupMessage}
                  icon="exclamation-triangle"
                  iconColor="#dc3545"
                >
                  <button onClick={closePopup} className="btn btn-primary">OK</button>
                </PopupModal>
              )}
            </div>
          </div>
        </div>

        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern Internationalal 2025</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ReviewSurrender;
